import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { SettingValue, Setting } from '../models/setting';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.url + 'setting/';
  }

  getSettingValue(key: string, tiendaId: number): Observable<SettingValue> {
    const params = new HttpParams()
      .set('key', key)
      .set('tiendaId', tiendaId.toString());

    let urlcom = this.url + "value";
    return this.http.get<SettingValue>(urlcom, { params });
  }

  getSettingsByTiendaId(tiendaId: number): Observable<Setting[]> {
    let urlcom = this.url + tiendaId;
    return this.http.get<Setting[]>(urlcom);
  }

  updateSettings(settings: Setting[]): Observable<Setting[]> {
    return this.http.put<Setting[]>(this.url, settings);
  }
}
